import React, {useContext} from "react";
import DropzoneComponent from "react-dropzone-component";
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import AppStore from "../AppStore";
import {useFormikContext} from "formik";


export default function UploadComponent(props) {
    const { validateForm } = useFormikContext();
    const appStore = useContext(AppStore);

    const config = {
        postUrl: appStore.getApiUriPrefix() + '/bookings/' + appStore.getCredentials().bookingCode + '/upload_file'
    };

    // For a full list of possible configurations,
    // please consult http://www.dropzonejs.com/#configuration
    const djsConfig = {
        addRemoveLinks: true,
        acceptedFiles: "image/*",
        paramName: "file",
        maxFiles: 1,

        dictDefaultMessage: props.label, // 'Abrir camara / subir fotos',
        dictCancelUpload: 'Cancelar',
        dictRemoveFile: 'Eliminar',

        // Ver: resizeQuality ,etc
        resizeWidth: 1024
    };

    let myDropzone;

    // For a list of all possible events (there are many), see README.md!
    const eventHandlers = {
        init: function(dropzone) {
            myDropzone = dropzone;
        },

        // No encontre otra forma de limitar la cantidad de files
        maxfilesexceeded: function(file) {
            myDropzone.removeAllFiles();
            myDropzone.addFile(file);
            validateForm();
        },

        success: (file) => {
            if (file.xhr) {
                const token = JSON.parse(file.xhr.responseText)['token'];

                props.formFiles.push({'token' : token});
            }
            validateForm();
        },

        removedfile: (file) => {
            if (file.xhr) {
                const token = JSON.parse(file.xhr.responseText)['token'];

                for (let i=0; i<props.formFiles.length; i++) {
                    if (props.formFiles[i]['token']===token) {
                        props.formFiles.splice(i, 1);
                        break;
                    }
                }
            }
            validateForm();
        }
    }

    return (
        <DropzoneComponent
            config={config}
            eventHandlers={eventHandlers}
            djsConfig={djsConfig}
        />
    )
}
